import styled from 'styled-components';
import { brandColors } from 'styles/colors';
import { breakpoint, font, grid, GridSpacing } from 'styles/globals';
import { getColor, Theme } from 'styles/theme';
import Heading from 'styles/typography/Heading';

export const Hero = styled.div`
  position: relative;
`;

export const Wrapper = styled.div`
  margin-top: 20px;
  margin-bottom: 16px;

  @media (${breakpoint.mdMin}) {
    margin-top: 24px;
  }

  &.portrait {
    @media (${breakpoint.xlMin}) {
      margin-top: 48px;
      margin-bottom: 32px;
    }

    @media (${breakpoint.xxlMin}) {
      margin-bottom: 16px;
    }
  }
`;

export const Container = styled.div`
  position: relative;
  background-color: ${brandColors.own.surfaceBrand};
  padding: 16px;

  @media (${breakpoint.mdMin}) {
    padding: 24px;
    margin-left: auto;
    margin-right: auto;
    width: ${grid(10, 11, GridSpacing.md)};
  }

  @media (${breakpoint.xlMin}) {
    width: ${grid(10, 9, GridSpacing.xl)};
    padding: 48px;
    margin-left: 0px;
  }

  @media (${breakpoint.xxlMin}) {
    width: 976px;
    margin-left: auto;
    margin-right: auto;
  }

  &.portrait {
    @media (${breakpoint.xlMin}) {
      width: ${grid(11, 10, GridSpacing.xl)};
      padding: 48px;
    }

    @media (${breakpoint.xxlMin}) {
      width: 976px;
      margin-left: auto;
      margin-right: auto;
    }
  }

  &.full_bleed {
    @media (${breakpoint.xlMin}) {
      width: ${grid(8, 9, GridSpacing.xl)};
      margin-left: auto;
      margin-right: auto;
    }

    @media (${breakpoint.xxlMin}) {
      width: 976px;
    }
  }
`;

export const Title = styled(Heading)`
  margin: 0px;

  @media (${breakpoint.lgMin}) {
    font-size: 3.75rem;
  }

  &.portrait {
    @media (${breakpoint.xlMin}) {
      width: ${grid(8, 6, GridSpacing.xl)};
    }

    @media (${breakpoint.xxlMin}) {
      width: 648px;
    }
  }
`;

export const DekContainer = styled.div`
  background-color: ${brandColors.own.surfaceBrand};

  @media (${breakpoint.xlMin}) {
    left: 0;
    position: absolute;
    padding-left: 48px;
    padding-right: 48px;
    padding-bottom: 48px;
    width: ${grid(4, 4.5, GridSpacing.xl)};
  }

  @media (${breakpoint.xxlMin}) {
    width: 396px;
  }

  &.portrait {
    @media (${breakpoint.xlMin}) {
      position: relative;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
      width: ${grid(8, 6, GridSpacing.xl)};
    }

    @media (${breakpoint.xxlMin}) {
      width: 648px;
    }
  }

  &.full_bleed {
    @media (${breakpoint.xlMin}) {
      position: relative;
      padding-left: 0px;
      padding-right: 0px;
      padding-bottom: 0px;
      width: 100%;
    }
  }

  &.fortune_video {
    @media (${breakpoint.xxlMin}) {
      width: 396px;
    }
  }
`;

export const Dek = styled.div`
  margin-top: 16px;
  font-family: ${font.graphikCond};
  font-size: 24px;
  font-weight: 300;
  line-height: 26.4px;
  letter-spacing: 0.256px;

  @media (${breakpoint.xlMin}) {
    margin-top: 48px;
    font-size: 32px;
    line-height: 35.2px;
  }

  &.portrait {
    @media (${breakpoint.xlMin}) {
      margin-top: 16px;
    }
  }

  &.full_bleed {
    @media (${breakpoint.xlMin}) {
      margin-top: 16px;
    }
  }
`;

export const AuthorsContainer = styled.div`
  margin-top: 24px;
`;

export const Authors = styled.span``;

export const Date = styled.div`
  margin-top: 4px;
  font-family: ${font.graphikCond};
  font-size: 14px;
  font-weight: 300;
  letter-spacing: 1.2px;
  line-height: 21px;
  min-height: 21px;
`;

export const ImageContainer = styled.div<{ theme: Theme }>`
  position: relative;

  @media (${breakpoint.mdMin}) {
    background-color: ${brandColors.own.surfaceBrand};
    margin: auto;
    padding: 0px 24px;
    width: ${grid(10, 11, GridSpacing.md)};
  }

  @media (${breakpoint.xlMin}) {
    background-color: ${getColor('surfaceWhite')};
    margin: 0px;
    margin-left: auto;
    padding: 0px;
    width: ${grid(8, 6.5, GridSpacing.xl)};
  }

  @media (${breakpoint.xxlMin}) {
    width: 768px;
  }

  &.portrait {
    @media (${breakpoint.mdMin}) {
      width: ${grid(10, 11, GridSpacing.md)};
      padding-left: ${grid(1, 2, GridSpacing.md)};
      padding-right: ${grid(1, 2, GridSpacing.md)};
    }

    @media (${breakpoint.xlMin}) {
      position: absolute;
      right: 0;
      top: 48px;
      padding-left: 0px;
      padding-right: 0px;
      width: ${grid(3, 2, GridSpacing.xl)};
    }

    @media (${breakpoint.xxlMin}) {
      width: 416px;
    }
  }

  &.full_bleed {
    max-width: 1440px;
    @media (${breakpoint.mdMin}) {
      width: 100vw;
      margin-left: -24px;
      padding-left: 0px;
      padding-right: 0px;
    }

    @media (${breakpoint.xlMin}) {
      position: relative;
      margin-left: -48px;
    }
  }
`;

export const VideoContainer = styled.div<{ theme: Theme }>`
  width: 100%;

  @media (${breakpoint.mdMin}) {
    background-color: ${brandColors.own.surfaceBrand};
    margin: auto;
    padding: 0px 24px;
    width: ${grid(10, 11, GridSpacing.md)};
  }

  @media (${breakpoint.xlMin}) {
    background-color: ${getColor('surfaceWhite')};
    margin: 0px;
    margin-left: auto;
    padding: 0px;
    width: ${grid(8, 6.5, GridSpacing.xl)};
  }

  @media (${breakpoint.xxlMin}) {
    width: 764px;
  }
`;
